import { useState } from "react";
import { Box, Center } from "@chakra-ui/react";
import { useGetTransferHistoryQuery } from "apis";
import { ActionBar, PageMotion, Paginator, PoweredBy, TransferCard, CircularLoader, CloseWindow } from "components";
import configs from "config";
import ls from "utils/secureStorage";

const TransferHistory = () => {
  const limit = 7;
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading } = useGetTransferHistoryQuery({
    page: currentPage,
    limit,
  });

  const handleBack = () => {
    const URL = ls.get(configs.PERSIST_URL);
    window.location.replace(`/${URL}`);
  };

  return (
    <PageMotion px={{ base: "8px", "1sm": "4px" }}>
      <Box maxW="445px" m="0 auto" pos="relative">
        <ActionBar onBackClick={handleBack} title="Transfer History" />

        <Box mt="40px">
          {isLoading && <CircularLoader mb="8px" />}

          {!isLoading && data?.totalCount === 0 && (
            <Box fontWeight="500" textAlign="center">
              No Transaction
            </Box>
          )}

          {data?.data.map(
            ({ cryptoVolume, cryptoType, direction, reference, transferStatus, createdAt, _id, networkFee, processingFee }) => {
              const netCryptoAmount = cryptoVolume - networkFee - processingFee;
              return (
                <TransferCard
                  amount={direction === "in" ? netCryptoAmount : cryptoVolume}
                  createdAt={createdAt}
                  crypto={cryptoType}
                  description={reference}
                  status={transferStatus}
                  direction={direction}
                  key={`${_id}`}
                  _id={_id}
                />
              );
            }
          )}
        </Box>

        {data && data.totalCount > limit && (
          <Paginator
            totalCount={data?.totalCount!}
            page={currentPage}
            limit={limit}
            onPageChange={(page: number) => setCurrentPage(page)}
          />
        )}
      </Box>

      <Center>
        <CloseWindow mt={{ base: "0" }} />
      </Center>

      <PoweredBy />
    </PageMotion>
  );
};

export default TransferHistory;
